/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import { defineMessages } from 'react-intl'

/* Constants */
export const AUDIO_VIDEO_URL = 'https://rtc.tegona.com/appartenances/'
export const MAIL_TO = 'interpretariat@appartenances.ch'
export const INTERPRETER_TYPE = 'interpreter'
export const LANGUAGE_TYPE = 'language'
export const COUPLE_NATIONATLITY_LANGUAGE_TYPE = 'couple'
export const PRESTATION_TYPE_VIDEO_CODE = 40
export const PRESTATION_TYPE_PHONE_CODE = 30
export const PRESTATION_REPORT = 1
export const LANGUAGE_PRESTATION_REPORT = 2
export const INTERPRETER_PRESTATION_REPORT = 3
export const APPLICANT_PRESTATION_REPORT = 4
export const PAYING_CUSTOMER_PRESTATION_REPORT = 5
export const DELIVERY_NOTE_LIST_REPORT = 6
export const PRESTATION_REPORT_STATISTIC = 7
export const PRESTATION_REPORT_GENERAL = 8
export const PRESTATION_REPORT_PHOTO = 9
export const PRESTATION_REPORT_CREATION_DATE = 10
export const PRESTATION_REPORT_VALIDATION_DATE = 11
export const PRESTATION_NO_SIGNATURE = 'NO_SIGNATURE'
export const INTERPRETER_REMINDER_STEP = 1
export const RECOMMANDED_FIELDS = [
  'beneficiary_numbers.0.beneficiary',
  'consumers',
  'reason'
]

export const VERY_GOOD = 1
export const GOOD = 2
export const SUFFISANT = 3
export const INSUFFISANT = 4

export const ABSOLUTELY = 1
export const RATHER_YES = 2
export const RATHER_NO = 3
export const NOT_AT_ALL = 4

/* Language Code */
export const UKRAINIEN = 290

/* Prestation Type */
export const DEFAULT_PRESTATION_TYPE = 'PT0000000001'
export const PRESTATION_TYPE_PHONE_UID = 'PT0000000004'
export const PRESTATION_TYPE_VIDEO_UID = 'PT0000000005'
export const PRESTATION_TYPE_MEDIATION_UID = 'PT0000000006'

/* Constants Workflow */
export const WORKFLOW_NAME = 'prestation_workflow'
export const INVITATION_SENT_PRESTATION_STATUS = 'invitation_sent'
export const INVITATION_RESENT_PRESTATION_STATUS = 'invitation_resent'
export const ACCEPTED_PRESTATION_STATUS = 'accepted'
export const CONFIRMED_PRESTATION_STATUS = 'confirmed'
export const TO_VALIDATE_PRESTATION_STATUS = 'to_validate'
export const VALIDATED_PRESTATION_STATUS = 'validated'
export const CANCELLED_PRESTATION_STATUS = 'cancelled'
export const FAILED_PRESTATION_STATUS = 'failed'
export const RESENT_FAILED_PRESTATION_STATUS = 'resent_failed'
export const PAID_PRESTATION_STATUS = 'paid'
export const INVOICED_PRESTATION_STATUS = 'invoiced'
export const TO_VERIFY_PRESTATION_STATUS = 'to_verify'
export const CLOSED_PRESTATION_STATUS = 'closed'

/* Actions Constants */
export const SELECT_PRESTATION = 'prestation.SELECT_PRESTATION'
export const SELECT_PRESTATIONS = 'prestation.SELECT_PRESTATIONS'
export const SET_DATA = 'prestation.SET_DATA'
export const SET_STATIC_LOADED = 'prestation.SET_STATIC_LOADED'
export const SELECT_WORKFLOW_STEPS = 'prestation.SELECT_WORKFLOW_STEPS'

export const colors = {
  invitation_sent: '#9C27B0',
  invitation_resent: '#673570',
  accepted: '#795548',
  confirmed: '#4CAF50',
  validated: '#FF7043',
  cancelled: '#C62828',
  to_validate: '#FFAB00',
  invoiced: '#006064',
  paid: '#C2185B',
  to_verify: '#651FFF',
  closed: '#00695C',
  failed: '#3F51B5',
  resent_failed: '#0f1e70',
}

export const icons = {
  invitation_sent: 'mail',
  invitation_resent: 'mail',
  accepted: 'done',
  confirmed: 'access_time',
  validated: 'check_circle',
  cancelled: 'remove_circle_outline',
  to_validate: 'phonelink_ring',
  invoiced: 'payment',
  paid: 'offline_pin',
  closed: 'lock',
  to_verify: 'zoom_in',
  failed: 'error'
}

export const messages = defineMessages({
  FEED_TITLE: {
    id: 'prestation.FEED_TITLE',
    defaultMessage: 'FEED_TITLE'
  },
  DETAIL_TITLE_LABEL: {
    id: 'prestation.DETAIL_TITLE_LABEL',
    defaultMessage: 'DETAIL_TITLE_LABEL'
  },
  DETAIL_MAIN_INFORMATION_LABEL: {
    id: 'prestation.DETAIL_MAIN_INFORMATION_LABEL',
    defaultMessage: 'DETAIL_MAIN_INFORMATION_LABEL'
  },
  DETAIL_LOCATION_LABEL: {
    id: 'prestation.DETAIL_LOCATION_LABEL',
    defaultMessage: 'DETAIL_LOCATION_LABEL'
  },
  DETAIL_CRITERIAS_LABEL: {
    id: 'prestation.DETAIL_CRITERIAS_LABEL',
    defaultMessage: 'DETAIL_CRITERIAS_LABEL'
  },
  DETAIL_CONTRIBUTORS_LABEL: {
    id: 'prestation.DETAIL_CONTRIBUTORS_LABEL',
    defaultMessage: 'DETAIL_CONTRIBUTORS_LABEL'
  },
  SEND_INTERPRETER_EMAIL_LABEL: {
    id: 'prestation.SEND_INTERPRETER_EMAIL_LABEL',
    defaultMessage: 'SEND_INTERPRETER_EMAIL_LABEL'
  },
  DETAIL_INTERPRETER_LABEL: {
    id: 'prestation.DETAIL_INTERPRETER_LABEL',
    defaultMessage: 'DETAIL_INTERPRETER_LABEL'
  },
  DETAIL_NO_INTERPRETER_MESSAGE: {
    id: 'prestation.DETAIL_NO_INTERPRETER_MESSAGE',
    defaultMessage: 'DETAIL_NO_INTERPRETER_MESSAGE'
  },
  DETAIL_CONSUMER_LABEL: {
    id: 'prestation.DETAIL_CONSUMER_LABEL',
    defaultMessage: 'DETAIL_CONSUMER_LABEL'
  },
  'DETAIL_APPLICANT_LABEL': {
    id: 'prestation.DETAIL_APPLICANT_LABEL',
    defaultMessage: 'DETAIL_APPLICANT_LABEL'
  },
  'DETAIL_PAYING_CUSTOMER_LABEL': {
    id: 'prestation.DETAIL_PAYING_CUSTOMER_LABEL',
    defaultMessage: 'DETAIL_PAYING_CUSTOMER_LABEL'
  },
  'DETAIL_BENEFICIARY_LABEL': {
    id: 'prestation.DETAIL_BENEFICIARY_LABEL',
    defaultMessage: 'DETAIL_BENEFICIARY_LABEL'
  },
  'DETAIL_NO_CONSUMER_MESSAGE': {
    id: 'prestation.DETAIL_NO_CONSUMER_MESSAGE',
    defaultMessage: 'DETAIL_NO_CONSUMER_MESSAGE'
  },
  'DETAIL_NO_PAYING_CUSTOMER_MESSAGE': {
    id: 'prestation.DETAIL_NO_PAYING_CUSTOMER_MESSAGE',
    defaultMessage: 'DETAIL_NO_PAYING_CUSTOMER_MESSAGE'
  },
  'DETAIL_NO_BENEFICIARY_MESSAGE': {
    id: 'prestation.DETAIL_NO_BENEFICIARY_MESSAGE',
    defaultMessage: 'DETAIL_NO_BENEFICIARY_MESSAGE'
  },
  'DETAIL_INFORMATIONS_LABEL': {
    id: 'prestation.DETAIL_INFORMATIONS_LABEL',
    defaultMessage: 'DETAIL_INFORMATIONS_LABEL'
  },
  'DETAIL_PRESTATION_TYPE_LABEL': {
    id: 'prestation.DETAIL_PRESTATION_TYPE_LABEL',
    defaultMessage: 'DETAIL_PRESTATION_TYPE_LABEL'
  },
  'DETAIL_REASON_LABEL': {
    id: 'prestation.DETAIL_REASON_LABEL',
    defaultMessage: 'DETAIL_REASON_LABEL'
  },
  'DETAIL_NO_REASON_LABEL': {
    id: 'prestation.DETAIL_NO_REASON_LABEL',
    defaultMessage: 'DETAIL_NO_REASON_LABEL'
  },
  'DETAIL_REMARKS_LABEL': {
    id: 'prestation.DETAIL_REMARKS_LABEL',
    defaultMessage: 'DETAIL_REMARKS_LABEL'
  },
  'DETAIL_INVITATIONS_LABEL': {
    id: 'prestation.DETAIL_INVITATIONS_LABEL',
    defaultMessage: 'DETAIL_INVITATIONS_LABEL'
  },
  'STEP_ONE_AUTOCOMPLETE': {
    id: 'prestation.STEP_ONE_AUTOCOMPLETE',
    defaultMessage: 'STEP_ONE_AUTOCOMPLETE'
  },
  'TYPE_PRESTATION_LABEL': {
    id: 'prestation.TYPE_PRESTATION_LABEL',
    defaultMessage: 'TYPE_PRESTATION_LABEL'
  },
  'STEP_ONE_LANGUE': {
    id: 'prestation.STEP_ONE_LANGUE',
    defaultMessage: 'STEP_ONE_LANGUE'
  },
  'STEP_THREE_BENEFICIARY': {
    id: 'prestation.STEP_THREE_BENEFICIARY',
    defaultMessage: 'STEP_THREE_BENEFICIARY'
  },
  'STEP_THREE_BENEFICIARY_NUMBER_TYPE': {
    id: 'prestation.STEP_THREE_BENEFICIARY_NUMBER_TYPE',
    defaultMessage: 'STEP_THREE_BENEFICIARY_NUMBER_TYPE'
  },
  'STEP_THREE_BENEFICIARY_NUMBER': {
    id: 'prestation.STEP_THREE_BENEFICIARY_NUMBER',
    defaultMessage: 'STEP_THREE_BENEFICIARY_NUMBER'
  },
  'STEP_THREE_REASONS': {
    id: 'prestation.STEP_THREE_REASONS',
    defaultMessage: 'STEP_THREE_REASONS'
  },
  'STEP_THREE_REMARKS': {
    id: 'prestation.STEP_THREE_REMARKS',
    defaultMessage: 'STEP_THREE_REMARKS'
  },
  'STEP_THREE_CONSUMER': {
    id: 'prestation.STEP_THREE_CONSUMER',
    defaultMessage: 'STEP_THREE_CONSUMER'
  },
  'STEP_THREE_PAYING_CUSTOMER': {
    id: 'prestation.STEP_THREE_PAYING_CUSTOMER',
    defaultMessage: 'STEP_THREE_PAYING_CUSTOMER'
  },
  'STEP_THREE_FILL_CONSUMER_HINT_TEXT': {
    id: 'prestation.STEP_THREE_FILL_CONSUMER_HINT_TEXT',
    defaultMessage: 'STEP_THREE_FILL_CONSUMER_HINT_TEXT'
  },
  'STEP_THREE_FILL_BENEFICIARY_HINT_TEXT': {
    id: 'prestation.STEP_THREE_FILL_BENEFICIARY_HINT_TEXT',
    defaultMessage: 'STEP_THREE_FILL_BENEFICIARY_HINT_TEXT'
  },
  VALIDATE_BUTTON: {
    id: 'prestation.VALIDATE_BUTTON',
    defaultMessage: 'VALIDATE_BUTTON'
  },
  VALIDATE_EDIT_BUTTON: {
    id: 'prestation.VALIDATE_EDIT_BUTTON',
    defaultMessage: 'VALIDATE_EDIT_BUTTON'
  },
  'DATE_LABEL': {
    id: 'prestation.DATE_LABEL',
    defaultMessage: 'DATE_LABEL'
  },
  'START_LABEL': {
    id: 'prestation.START_LABEL',
    defaultMessage: 'START_LABEL'
  },
  'END_LABEL': {
    id: 'prestation.END_LABEL',
    defaultMessage: 'END_LABEL'
  },
  'RECOMMANDED_FIELD_TITLE': {
    id: 'prestation.RECOMMANDED_FIELD_TITLE',
    defaultMessage: 'RECOMMANDED_FIELD_TITLE'
  },
  'RECOMMANDED_FIELD_MESSAGE1': {
    id: 'prestation.RECOMMANDED_FIELD_MESSAGE1',
    defaultMessage: 'RECOMMANDED_FIELD_MESSAGE1'
  },
  'RECOMMANDED_FIELD_MESSAGE2': {
    id: 'prestation.RECOMMANDED_FIELD_MESSAGE2',
    defaultMessage: 'RECOMMANDED_FIELD_MESSAGE2'
  },
  'NO_RECOMMANDED_FIELD_ACTION': {
    id: 'prestation.NO_RECOMMANDED_FIELD_ACTION',
    defaultMessage: 'NO_RECOMMANDED_FIELD_ACTION'
  },
  'YES_RECOMMANDED_FIELD_ACTION': {
    id: 'prestation.YES_RECOMMANDED_FIELD_ACTION',
    defaultMessage: 'YES_RECOMMANDED_FIELD_ACTION'
  },
  APPLICANT_PROPOSAL_MESSAGE: {
    id: 'prestation.APPLICANT_PROPOSAL_MESSAGE',
    defaultMessage: 'APPLICANT_PROPOSAL_MESSAGE'
  },
  INTERPRETER_PROPOSAL_MESSAGE: {
    id: 'prestation.INTERPRETER_PROPOSAL_MESSAGE',
    defaultMessage: 'INTERPRETER_PROPOSAL_MESSAGE'
  },
  PROPOSAL_REFUSED_APPLICANT_MESSAGE: {
    id: 'prestation.PROPOSAL_REFUSED_APPLICANT_MESSAGE',
    defaultMessage: 'PROPOSAL_REFUSED_APPLICANT_MESSAGE'
  },
  PROPOSAL_REFUSED_INTERPRETER_MESSAGE: {
    id: 'prestation.PROPOSAL_REFUSED_INTERPRETER_MESSAGE',
    defaultMessage: 'PROPOSAL_REFUSED_INTERPRETER_MESSAGE'
  },
  SEND_PROPOSITION_LABEL: {
    id: 'prestation.SEND_PROPOSITION_LABEL',
    defaultMessage: 'SEND_PROPOSITION_LABEL'
  },
  'STEP_THREE_OTHER_CONTRIBUTORS': {
    id: 'prestation.STEP_THREE_OTHER_CONTRIBUTORS',
    defaultMessage: 'STEP_THREE_OTHER_CONTRIBUTORS'
  },
  'PRESTATION_ACTIONS_LABEL': {
    id: 'prestation.PRESTATION_ACTIONS_LABEL',
    defaultMessage: 'PRESTATION_ACTIONS_LABEL'
  },
  'EDIT_ACTION_LABEL': {
    id: 'prestation.EDIT_ACTION_LABEL',
    defaultMessage: 'EDIT_ACTION_LABEL'
  },
  'CANCEL_ACTION_LABEL': {
    id: 'prestation.CANCEL_ACTION_LABEL',
    defaultMessage: 'CANCEL_ACTION_LABEL'
  },
  'CANCELLATION_CONFIRMATION_FIELD_TITLE': {
    id: 'prestation.CANCELLATION_CONFIRMATION_FIELD_TITLE',
    defaultMessage: 'CANCELLATION_CONFIRMATION_FIELD_TITLE'
  },
  'CANCELLATION_CONFIRMATION_FIELD_MESSAGE_OPTIONAL': {
    id: 'prestation.CANCELLATION_CONFIRMATION_FIELD_MESSAGE_OPTIONAL',
    defaultMessage: 'CANCELLATION_CONFIRMATION_FIELD_MESSAGE_OPTIONAL'
  },
  'CANCELLATION_CONFIRMATION_FIELD_MESSAGE_MANDATORY': {
    id: 'prestation.CANCELLATION_CONFIRMATION_FIELD_MESSAGE_MANDATORY',
    defaultMessage: 'CANCELLATION_CONFIRMATION_FIELD_MESSAGE_MANDATORY'
  },
  'CANCELLATION_COMMENT_LABEL_OPTIONAL': {
    id: 'prestation.CANCELLATION_COMMENT_LABEL_OPTIONAL',
    defaultMessage: 'CANCELLATION_COMMENT_LABEL_OPTIONAL'
  },
  'CANCELLATION_COMMENT_LABEL_MANDATORY': {
    id: 'prestation.CANCELLATION_COMMENT_LABEL_MANDATORY',
    defaultMessage: 'CANCELLATION_COMMENT_LABEL_MANDATORY'
  },
  'NO_CANCELLATION_ACTION': {
    id: 'prestation.NO_CANCELLATION_ACTION',
    defaultMessage: 'NO_CANCELLATION_ACTION'
  },
  'YES_CANCELLATION_ACTION': {
    id: 'prestation.YES_CANCELLATION_ACTION',
    defaultMessage: 'YES_CANCELLATION_ACTION'
  },
  'STEP_THREE_PAYING_CUSTOMER_HINT_TEXT': {
    id: 'prestation.STEP_THREE_PAYING_CUSTOMER_HINT_TEXT',
    defaultMessage: 'STEP_THREE_PAYING_CUSTOMER_HINT_TEXT'
  },
  'STEP_THREE_ADDITIONAL_ADDRESS_LINE': {
    id: 'prestation.STEP_THREE_ADDITIONAL_ADDRESS_LINE',
    defaultMessage: 'STEP_THREE_ADDITIONAL_ADDRESS_LINE'
  },
  'SEARCH_TOOL_TITLE': {
    id: 'search.SEARCH_TOOL_TITLE',
    defaultMessage: 'SEARCH_TOOL_TITLE'
  },
  'SEARCH_ACTION_TITLE': {
    id: 'search.SEARCH_ACTION_TITLE',
    defaultMessage: 'SEARCH_ACTION_TITLE'
  },
  'BEFORE_LABEL': {
    id: 'search.BEFORE_LABEL',
    defaultMessage: 'BEFORE_LABEL'
  },
  'AFTER_LABEL': {
    id: 'search.AFTER_LABEL',
    defaultMessage: 'AFTER_LABEL'
  },
  'SEARCH_DATE_LABEL': {
    id: 'search.SEARCH_DATE_LABEL',
    defaultMessage: 'SEARCH_DATE_LABEL'
  },
  'HISTORY_PAYING_CUSTOMER_LABEL': {
    id: 'search.HISTORY_PAYING_CUSTOMER_LABEL',
    defaultMessage: 'HISTORY_PAYING_CUSTOMER_LABEL'
  },
  HISTORY_APPLICANT_LABEL: {
    id: 'search.HISTORY_APPLICANT_LABEL',
    defaultMessage: 'HISTORY_APPLICANT_LABEL'
  },
  'HISTORY_APPLICANT_ENTITY_LABEL': {
    id: 'search.HISTORY_APPLICANT_ENTITY_LABEL',
    defaultMessage: 'HISTORY_APPLICANT_ENTITY_LABEL'
  },
  'HISTORY_APPLICANT_IDENTITY_LABEL': {
    id: 'search.HISTORY_APPLICANT_IDENTITY_LABEL',
    defaultMessage: 'HISTORY_APPLICANT_IDENTITY_LABEL'
  },
  'SEARCH_OTHER_CRITERIAS_LABEL': {
    id: 'search.SEARCH_OTHER_CRITERIAS_LABEL',
    defaultMessage: 'SEARCH_OTHER_CRITERIAS_LABEL'
  },
  'HISTORY_INTERPRETER_LABEL': {
    id: 'search.HISTORY_INTERPRETER_LABEL',
    defaultMessage: 'HISTORY_INTERPRETER_LABEL'
  },
  'LANGUAGES_LABEL': {
    id: 'search.LANGUAGES_LABEL',
    defaultMessage: 'LANGUAGES_LABEL'
  },
  'ORIGIN_LABEL': {
    id: 'search.ORIGIN_LABEL',
    defaultMessage: 'ORIGIN_LABEL'
  },
  'PRESTATION_TYPE_LABEL': {
    id: 'search.PRESTATION_TYPE_LABEL',
    defaultMessage: 'PRESTATION_TYPE_LABEL'
  },
  'STATUS_LABEL': {
    id: 'search.STATUS_LABEL',
    defaultMessage: 'STATUS_LABEL'
  },
  'NO_AVAILABILITY_MESSAGE': {
    id: 'availability.NO_AVAILABILITY_MESSAGE',
    defaultMessage: 'NO_AVAILABILITY_MESSAGE'
  },
  'AVAILABLE_DATES_MESSAGE': {
    id: 'availability.AVAILABLE_DATES_MESSAGE',
    defaultMessage: 'AVAILABLE_DATES_MESSAGE'
  },
  'DATE_MESSAGE': {
    id: 'availability.DATE_MESSAGE',
    defaultMessage: 'DATE_MESSAGE'
  },
  'FROM_HOUR_MESSAGE': {
    id: 'availability.FROM_HOUR_MESSAGE',
    defaultMessage: 'FROM_HOUR_MESSAGE'
  },
  'TO_HOUR_MESSAGE': {
    id: 'availability.TO_HOUR_MESSAGE',
    defaultMessage: 'TO_HOUR_MESSAGE'
  },
  'DISTANCE_LABEL': {
    id: 'matching.DISTANCE_LABEL',
    defaultMessage: 'DISTANCE_LABEL'
  },
  'INTERPRETER_CONTACT_LABEL': {
    id: 'matching.INTERPRETER_CONTACT_LABEL',
    defaultMessage: 'INTERPRETER_CONTACT_LABEL'
  },
  'PROPOSAL_ACTION_LABEL': {
    id: 'prestation.PROPOSAL_ACTION_LABEL',
    defaultMessage: 'PROPOSAL_ACTION_LABEL'
  },
  'PROPOSAL_LABEL': {
    id: 'prestation.PROPOSAL_LABEL',
    defaultMessage: 'PROPOSAL_LABEL'
  },
  CANCEL_BUTTON: {
    id: 'prestation.CANCEL_BUTTON',
    defaultMessage: 'CANCEL_BUTTON'
  },
  'SUB_DETAIL_TITLE_LABEL': {
    id: 'prestation.SUB_DETAIL_TITLE_LABEL',
    defaultMessage: 'SUB_DETAIL_TITLE_LABEL'
  },
  'PRESTATION_HISTORY_LABEL': {
    id: 'prestation.PRESTATION_HISTORY_LABEL',
    defaultMessage: 'PRESTATION_HISTORY_LABEL'
  },
  CLEAN_SEARCH: {
    id: 'prestation.CLEAN_SEARCH',
    defaultMessage: 'CLEAN_SEARCH'
  },
  HISTORY_SEARCH: {
    id: 'prestation.HISTORY_SEARCH',
    defaultMessage: 'HISTORY_SEARCH'
  },
  'RESULTS_TITLE': {
    id: 'prestation.RESULTS_TITLE',
    defaultMessage: 'RESULTS_TITLE'
  },
  'CONTRIBUTORS_SEARCH_LABEL': {
    id: 'prestation.CONTRIBUTORS_SEARCH_LABEL',
    defaultMessage: 'CONTRIBUTORS_SEARCH_LABEL'
  },
  'INTERPRETER_PROPOSAL_TO_REVIEW_LABEL': {
    id: 'prestation.INTERPRETER_PROPOSAL_TO_REVIEW_LABEL',
    defaultMessage: 'INTERPRETER_PROPOSAL_TO_REVIEW_LABEL'
  },
  'RESULTS_NUMBER': {
    id: 'prestation.RESULTS_NUMBER',
    defaultMessage: 'RESULTS_NUMBER'
  },
  'NO_RESULTS_NUMBER': {
    id: 'prestation.NO_RESULTS_NUMBER',
    defaultMessage: 'NO_RESULTS_NUMBER'
  },
  'SEARCH_UID_LABEL': {
    id: 'prestation.SEARCH_UID_LABEL',
    defaultMessage: 'SEARCH_UID_LABEL'
  },
  'ADD_CONSUMER': {
    id: 'prestation.ADD_CONSUMER',
    defaultMessage: 'ADD_CONSUMER'
  },
  'ADD_BENEFICIARY': {
    id: 'prestation.ADD_BENEFICIARY',
    defaultMessage: 'ADD_BENEFICIARY'
  },
  'CREATION_DATE_TIME_LABEL': {
    id: 'prestation.CREATION_DATE_TIME_LABEL',
    defaultMessage: 'CREATION_DATE_TIME_LABEL'
  },
  'INTERPRETER_PROPOSAL_APPLICANT_MESSAGE': {
    id: 'prestation.INTERPRETER_PROPOSAL_APPLICANT_MESSAGE',
    defaultMessage: 'INTERPRETER_PROPOSAL_APPLICANT_MESSAGE'
  },
  'APPLICANT_PROPOSAL_INTERPRETER_MESSAGE': {
    id: 'prestation.APPLICANT_PROPOSAL_INTERPRETER_MESSAGE',
    defaultMessage: 'APPLICANT_PROPOSAL_INTERPRETER_MESSAGE'
  },
  'DOCUMENTS_MESSAGE': {
    id: 'prestation.DOCUMENTS_MESSAGE',
    defaultMessage: 'DOCUMENTS_MESSAGE'
  },
  'STEP_THREE_OTHER_BENEFICIARIES': {
    id: 'prestation.STEP_THREE_OTHER_BENEFICIARIES',
    defaultMessage: 'STEP_THREE_OTHER_BENEFICIARIES'
  },
  'DETAIL_OTHER_BENEFICIARIES_LABEL': {
    id: 'prestation.DETAIL_OTHER_BENEFICIARIES_LABEL',
    defaultMessage: 'DETAIL_OTHER_BENEFICIARIES_LABEL'
  },
  'DETAIL_NO_OTHER_BENEFICIARY_MESSAGE': {
    id: 'prestation.DETAIL_NO_OTHER_BENEFICIARY_MESSAGE',
    defaultMessage: 'DETAIL_NO_OTHER_BENEFICIARY_MESSAGE'
  },
  DETAIL_PROPOSALS_LABEL: {
    id: 'prestation.DETAIL_PROPOSALS_LABEL',
    defaultMessage: 'DETAIL_PROPOSALS_LABEL'
  },
  DETAIL_PROPOSALS_ONGOING: {
    id: 'prestation.DETAIL_PROPOSALS_ONGOING',
    defaultMessage: 'DETAIL_PROPOSALS_ONGOING'
  },
  DETAIL_PROPOSALS_CLOSED: {
    id: 'prestation.DETAIL_PROPOSALS_CLOSED',
    defaultMessage: 'DETAIL_PROPOSALS_CLOSED'
  },
  DETAIL_PROPOSALS_SENT: {
    id: 'prestation.DETAIL_PROPOSALS_SENT',
    defaultMessage: 'DETAIL_PROPOSALS_SENT'
  },
  DETAIL_PROPOSALS_RECEIVED: {
    id: 'prestation.DETAIL_PROPOSALS_RECEIVED',
    defaultMessage: 'DETAIL_PROPOSALS_RECEIVED'
  },
  DETAIL_VALIDATION_LABEL: {
    id: 'prestation.DETAIL_VALIDATION_LABEL',
    defaultMessage: 'DETAIL_VALIDATION_LABEL'
  },
  DETAIL_HAPPENED_LABEL: {
    id: 'prestation.DETAIL_HAPPENED_LABEL',
    defaultMessage: 'DETAIL_HAPPENED_LABEL'
  },
  DETAIL_HAPPENED_MESSAGE: {
    id: 'prestation.DETAIL_HAPPENED_MESSAGE',
    defaultMessage: 'DETAIL_HAPPENED_MESSAGE'
  },
  DETAIL_NOT_HAPPENED_MESSAGE: {
    id: 'prestation.DETAIL_NOT_HAPPENED_MESSAGE',
    defaultMessage: 'DETAIL_NOT_HAPPENED_MESSAGE'
  },
  DETAIL_NOT_HAPPENED_REASON_LABEL: {
    id: 'prestation.DETAIL_NOT_HAPPENED_REASON_LABEL',
    defaultMessage: 'DETAIL_NOT_HAPPENED_REASON_LABEL'
  },
  DETAIL_INTERPRETER_TRAVEL_LABEL: {
    id: 'prestation.DETAIL_INTERPRETER_TRAVEL_LABEL',
    defaultMessage: 'DETAIL_INTERPRETER_TRAVEL_LABEL'
  },
  DETAIL_INTERPRETER_TRAVELLED_MESSAGE: {
    id: 'prestation.DETAIL_INTERPRETER_TRAVELLED_MESSAGE',
    defaultMessage: 'DETAIL_INTERPRETER_TRAVELLED_MESSAGE'
  },
  DETAIL_INTERPRETER_NOT_TRAVELLED_MESSAGE: {
    id: 'prestation.DETAIL_INTERPRETER_NOT_TRAVELLED_MESSAGE',
    defaultMessage: 'DETAIL_INTERPRETER_NOT_TRAVELLED_MESSAGE'
  },
  DETAIL_VALIDATION_REMARKS_LABEL: {
    id: 'prestation.DETAIL_VALIDATION_REMARKS_LABEL',
    defaultMessage: 'DETAIL_VALIDATION_REMARKS_LABEL'
  },
  HISTORY_EXPORT_CSV_LABEL: {
    id: 'prestation.HISTORY_EXPORT_CSV_LABEL',
    defaultMessage: 'HISTORY_EXPORT_CSV_LABEL'
  },
  GENERAL_EXPORT_CSV_LABEL: {
    id: 'prestation.GENERAL_EXPORT_CSV_LABEL',
    defaultMessage: 'GENERAL_EXPORT_CSV_LABEL'
  },
  DETAIL_VALIDATION_SIGNATURE_LABEL: {
    id: 'prestation.DETAIL_VALIDATION_SIGNATURE_LABEL',
    defaultMessage: 'DETAIL_VALIDATION_SIGNATURE_LABEL'
  },
  DETAIL_VALIDATION_ADDITIONAL_SERVICE_LABEL: {
    id: 'prestation.DETAIL_VALIDATION_ADDITIONAL_SERVICE_LABEL',
    defaultMessage: 'DETAIL_VALIDATION_ADDITIONAL_SERVICE_LABEL'
  },
  DETAIL_VALIDATION_ADDITIONAL_SERVICE_REASON_LABEL: {
    id: 'prestation.DETAIL_VALIDATION_ADDITIONAL_SERVICE_REASON_LABEL',
    defaultMessage: 'DETAIL_VALIDATION_ADDITIONAL_SERVICE_REASON_LABEL'
  },
  DETAIL_VALIDATION_INTERPRETER_DELAY_LABEL: {
    id: 'prestation.DETAIL_VALIDATION_INTERPRETER_DELAY_LABEL',
    defaultMessage: 'DETAIL_VALIDATION_INTERPRETER_DELAY_LABEL'
  },
  MINUTES_LABEL: {
    id: 'prestation.MINUTES_LABEL',
    defaultMessage: 'MINUTES_LABEL'
  },
  STATISTIC_CSV_FILE_LABEL: {
    id: 'prestation.STATISTIC_CSV_FILE_LABEL',
    defaultMessage: 'STATISTIC_CSV_FILE_LABEL'
  },
  STATISTIC_EXPORT_CSV_LABEL: {
    id: 'prestation.STATISTIC_EXPORT_CSV_LABEL',
    defaultMessage: 'STATISTIC_EXPORT_CSV_LABEL'
  },
  PHOTO_EXPORT_CSV_LABEL: {
    id: 'prestation.PHOTO_EXPORT_CSV_LABEL',
    defaultMessage: 'PHOTO_EXPORT_CSV_LABEL'
  },
  CREATION_DATE_EXPORT_CSV_LABEL: {
    id: 'prestation.CREATION_DATE_EXPORT_CSV_LABEL',
    defaultMessage: 'CREATION_DATE_EXPORT_CSV_LABEL'
  },
  VALIDATION_DATE_EXPORT_CSV_LABEL: {
    id: 'prestation.VALIDATION_DATE_EXPORT_CSV_LABEL',
    defaultMessage: 'VALIDATION_DATE_EXPORT_CSV_LABEL'
  },
  HISTORY_EXPORT_LANGUAGE_CSV_LABEL: {
    id: 'prestation.HISTORY_EXPORT_LANGUAGE_CSV_LABEL',
    defaultMessage: 'HISTORY_EXPORT_LANGUAGE_CSV_LABEL'
  },
  HISTORY_EXPORT_INTERPRETER_CSV_LABEL: {
    id: 'prestation.HISTORY_EXPORT_INTERPRETER_CSV_LABEL',
    defaultMessage: 'HISTORY_EXPORT_INTERPRETER_CSV_LABEL'
  },
  HISTORY_EXPORT_APPLICANT_CSV_LABEL: {
    id: 'prestation.HISTORY_EXPORT_APPLICANT_CSV_LABEL',
    defaultMessage: 'HISTORY_EXPORT_APPLICANT_CSV_LABEL'
  },
  HISTORY_EXPORT_PAYING_CUSTOMER_CSV_LABEL: {
    id: 'prestation.HISTORY_EXPORT_PAYING_CUSTOMER_CSV_LABEL',
    defaultMessage: 'HISTORY_EXPORT_PAYING_CUSTOMER_CSV_LABEL'
  },
  HISTORY_BENEFICIARY_NUMBER_LABEL: {
    id: 'prestation.HISTORY_BENEFICIARY_NUMBER_LABEL',
    defaultMessage: 'HISTORY_BENEFICIARY_NUMBER_LABEL'
  },
  BILLING_LABEL: {
    id: 'prestation.BILLING_LABEL',
    defaultMessage: 'BILLING_LABEL'
  },
  HISTORY_INVITED_INTERPRETER_LABEL: {
    id: 'prestation.HISTORY_INVITED_INTERPRETER_LABEL',
    defaultMessage: 'HISTORY_INVITED_INTERPRETER_LABEL'
  },
  PAST_PRESTATION_LABEL_ERROR: {
    id: 'prestation.PAST_PRESTATION_LABEL_ERROR',
    defaultMessage: 'PAST_PRESTATION_LABEL_ERROR'
  },
  MISSING_INTERPRETER_LABEL_ERROR: {
    id: 'prestation.MISSING_INTERPRETER_LABEL_ERROR',
    defaultMessage: 'MISSING_INTERPRETER_LABEL_ERROR'
  },
  CONFIRM_AUTO_LABEL: {
    id: 'prestation.CONFIRM_AUTO_LABEL',
    defaultMessage: 'CONFIRM_AUTO_LABEL'
  },
  VALIDATION_NO_SIGNATURE_LABEL: {
    id: 'prestation.VALIDATION_NO_SIGNATURE_LABEL',
    defaultMessage: 'VALIDATION_NO_SIGNATURE_LABEL'
  },
  STEP_THREE_HAPPENED_LABEL: {
    id: 'prestation.STEP_THREE_HAPPENED_LABEL',
    defaultMessage: 'STEP_THREE_HAPPENED_LABEL'
  },
  STEP_THREE_INTERPRETER_TRAVEL_LABEL: {
    id: 'prestation.STEP_THREE_INTERPRETER_TRAVEL_LABEL',
    defaultMessage: 'STEP_THREE_INTERPRETER_TRAVEL_LABEL'
  },
  STEP_THREE_BILLING_LABEL: {
    id: 'prestation.STEP_THREE_BILLING_LABEL',
    defaultMessage: 'STEP_THREE_BILLING_LABEL'
  },
  STEP_THREE_DATE_LABEL: {
    id: 'prestation.STEP_THREE_DATE_LABEL',
    defaultMessage: 'STEP_THREE_DATE_LABEL'
  },
  STEP_THREE_START_LABEL: {
    id: 'prestation.STEP_THREE_START_LABEL',
    defaultMessage: 'STEP_THREE_START_LABEL'
  },
  STEP_THREE_END_LABEL: {
    id: 'prestation.STEP_THREE_END_LABEL',
    defaultMessage: 'STEP_THREE_END_LABEL'
  },
  STEP_THREE_ADDITIONNAL_SERVICES_LABEL: {
    id: 'prestation.STEP_THREE_ADDITIONNAL_SERVICES_LABEL',
    defaultMessage: 'STEP_THREE_ADDITIONNAL_SERVICES_LABEL'
  },
  STEP_THREE_INTERPRETER_DELAY_LABEL: {
    id: 'prestation.STEP_THREE_INTERPRETER_DELAY_LABEL',
    defaultMessage: 'STEP_THREE_INTERPRETER_DELAY_LABEL'
  },
  HISTORY_CONSUMER_ENTITY_LABEL: {
    id: 'prestation.HISTORY_CONSUMER_ENTITY_LABEL',
    defaultMessage: 'HISTORY_CONSUMER_ENTITY_LABEL'
  },
  HISTORY_CONSUMER_IDENTITY_LABEL: {
    id: 'prestation.HISTORY_CONSUMER_IDENTITY_LABEL',
    defaultMessage: 'HISTORY_CONSUMER_IDENTITY_LABEL'
  },
  HISTORY_ADDRESS_LABEL: {
    id: 'prestation.HISTORY_ADDRESS_LABEL',
    defaultMessage: 'HISTORY_ADDRESS_LABEL'
  },
  ADMINISTRATION_LABEL: {
    id: 'prestation.ADMINISTRATION_LABEL',
    defaultMessage: 'ADMINISTRATION_LABEL'
  },
  FACTURATION_LABEL: {
    id: 'prestation.FACTURATION_LABEL',
    defaultMessage: 'FACTURATION_LABEL'
  },
  REMUNERATION_LABEL: {
    id: 'prestation.REMUNERATION_LABEL',
    defaultMessage: 'REMUNERATION_LABEL'
  },
  GENERAL_EXPORT_ALERT: {
    id: 'prestation.GENERAL_EXPORT_ALERT',
    defaultMessage: 'GENERAL_EXPORT_ALERT'
  },
  INVOICE_ORDER_EXPORT_MESSAGE: {
    id: 'prestation.INVOICE_ORDER_EXPORT_MESSAGE',
    defaultMessage: 'INVOICE_ORDER_EXPORT_MESSAGE'
  },
  INVOICE_ORDER_EXPORT_TITLE: {
    id: 'prestation.INVOICE_ORDER_EXPORT_TITLE',
    defaultMessage: 'INVOICE_ORDER_EXPORT_TITLE'
  },
  SALARY_INVOICE_EXPORT_MESSAGE: {
    id: 'prestation.SALARY_INVOICE_EXPORT_MESSAGE',
    defaultMessage: 'SALARY_INVOICE_EXPORT_MESSAGE'
  },
  SALARY_INVOICE_EXPORT_TITLE: {
    id: 'prestation.SALARY_INVOICE_EXPORT_TITLE',
    defaultMessage: 'SALARY_INVOICE_EXPORT_TITLE'
  },
  PRESTATION_ADMIN_REMARKS_LABEL: {
    id: 'prestation.PRESTATION_ADMIN_REMARKS_LABEL',
    defaultMessage: 'PRESTATION_ADMIN_REMARKS_LABEL'
  },
  PRESTATION_ADMIN_REMARKS_MESSAGE: {
    id: 'prestation.PRESTATION_ADMIN_REMARKS_MESSAGE',
    defaultMessage: 'PRESTATION_ADMIN_REMARKS_MESSAGE'
  },
  VALIDATION_LABEL: {
    id: 'prestation.VALIDATION_LABEL',
    defaultMessage: 'VALIDATION_LABEL'
  },
  DETAIL_VALIDATION_BAR_CODE_LABEL: {
    id: 'prestation.DETAIL_VALIDATION_BAR_CODE_LABEL',
    defaultMessage: 'DETAIL_VALIDATION_BAR_CODE_LABEL'
  },
  DETAIL_VALIDATION_DOCUMENT_LABEL: {
    id: 'prestation.DETAIL_VALIDATION_DOCUMENT_LABEL',
    defaultMessage: 'DETAIL_VALIDATION_DOCUMENT_LABEL'
  },
  BILLING_EXPORT_LABEL: {
    id: 'prestation.BILLING_EXPORT_LABEL',
    defaultMessage: 'BILLING_EXPORT_LABEL'
  },
  DELIVERY_NOTE_ACTION: {
    id: 'prestation.DELIVERY_NOTE_ACTION',
    defaultMessage: 'DELIVERY_NOTE_ACTION'
  },
  STEP_THREE_ORDERED_DATETIME: {
    id: 'prestation.STEP_THREE_ORDERED_DATETIME',
    defaultMessage: 'STEP_THREE_ORDERED_DATETIME'
  },
  STEP_THREE_DELIVERED_DATETIME: {
    id: 'prestation.STEP_THREE_DELIVERED_DATETIME',
    defaultMessage: 'STEP_THREE_DELIVERED_DATETIME'
  },
  DETAIL_ORDERED_DATETIME_LABEL: {
    id: 'prestation.DETAIL_ORDERED_DATETIME_LABEL',
    defaultMessage: 'DETAIL_ORDERED_DATETIME_LABEL'
  },
  DETAIL_DELIVERED_DATETIME_LABEL: {
    id: 'prestation.DETAIL_DELIVERED_DATETIME_LABEL',
    defaultMessage: 'DETAIL_DELIVERED_DATETIME_LABEL'
  },
  DETAIL_PICTURE_AVAILABLE_LABEL: {
    id: 'prestation.DETAIL_PICTURE_AVAILABLE_LABEL',
    defaultMessage: 'DETAIL_PICTURE_AVAILABLE_LABEL'
  },
  SEARCH_INVOICE_ABA_CODE_LABEL: {
    id: 'prestation.SEARCH_INVOICE_ABA_CODE_LABEL',
    defaultMessage: 'SEARCH_INVOICE_ABA_CODE_LABEL'
  },
  STEP_THREE_INVOICE_ONLY_ADDITIONAL_SERVICES_LABEL: {
    id: 'prestation.STEP_THREE_INVOICE_ONLY_ADDITIONAL_SERVICES_LABEL',
    defaultMessage: 'STEP_THREE_INVOICE_ONLY_ADDITIONAL_SERVICES_LABEL'
  },
  SEARCH_INVOICE_DATE_LABEL: {
    id: 'prestation.SEARCH_INVOICE_DATE_LABEL',
    defaultMessage: 'SEARCH_INVOICE_DATE_LABEL'
  },
  VIDEO_FORM_TITLE: {
    id: 'prestation.VIDEO_FORM_TITLE',
    defaultMessage: 'VIDEO_FORM_TITLE'
  },
  INTERPRETER_LANGUAGE_AUTOCOMPLETE: {
    id: 'prestation.INTERPRETER_LANGUAGE_AUTOCOMPLETE',
    defaultMessage: 'INTERPRETER_LANGUAGE_AUTOCOMPLETE'
  },
  START_PRESTATION_LABEL: {
    id: 'prestation.START_PRESTATION_LABEL',
    defaultMessage: 'START_PRESTATION_LABEL'
  },
  INTERPRETERS_NOT_AVAILABLE: {
    id: 'prestation.INTERPRETERS_NOT_AVAILABLE',
    defaultMessage: 'INTERPRETERS_NOT_AVAILABLE'
  },
  INVOICE_ABA_CODE_LABEL: {
    id: 'prestation.INVOICE_ABA_CODE_LABEL',
    defaultMessage: 'INVOICE_ABA_CODE_LABEL'
  },
  INVOICE_DATE_LABEL: {
    id: 'prestation.INVOICE_DATE_LABEL',
    defaultMessage: 'INVOICE_DATE_LABEL'
  },
  IMAGE_ERROR_MESSAGE_LABEL: {
    id: 'prestation.IMAGE_ERROR_MESSAGE_LABEL',
    defaultMessage: 'IMAGE_ERROR_MESSAGE_LABEL'
  },
  UPLOAD_IMAGE_LABEL: {
    id: 'prestation.UPLOAD_IMAGE_LABEL',
    defaultMessage: 'UPLOAD_IMAGE_LABEL'
  },
  DELETE_DOCUMENT_CONFIRMATION_TITLE: {
    id: 'prestation.DELETE_DOCUMENT_CONFIRMATION_TITLE',
    defaultMessage: 'DELETE_DOCUMENT_CONFIRMATION_TITLE'
  },
  DELETE_DOCUMENT_CONFIRMATION_MESSAGE: {
    id: 'prestation.DELETE_DOCUMENT_CONFIRMATION_MESSAGE',
    defaultMessage: 'DELETE_DOCUMENT_CONFIRMATION_MESSAGE'
  },
  STEP_ONE_SEVERAL_LANGUAGES: {
    id: 'prestation.STEP_ONE_SEVERAL_LANGUAGES',
    defaultMessage: 'STEP_ONE_SEVERAL_LANGUAGES'
  },
  LOADING_PLEASE_WAIT_MESSAGE1: {
    id: 'prestation.LOADING_PLEASE_WAIT_MESSAGE1',
    defaultMessage: 'LOADING_PLEASE_WAIT_MESSAGE1'
  },
  LOADING_PLEASE_WAIT_MESSAGE2: {
    id: 'prestation.LOADING_PLEASE_WAIT_MESSAGE2',
    defaultMessage: 'LOADING_PLEASE_WAIT_MESSAGE2'
  },
  REMINDER_PHOTO_ACTION_LABEL: {
    id: 'prestation.REMINDER_PHOTO_ACTION_LABEL',
    defaultMessage: 'REMINDER_PHOTO_ACTION_LABEL'
  },
  VALIDATION_DISTANCE_SENT: {
    id: 'prestation.VALIDATION_DISTANCE_SENT',
    defaultMessage: 'VALIDATION_DISTANCE_SENT'
  },
  INTERPRETER_UNAVAILABLE: {
    id: 'prestation.INTERPRETER_UNAVAILABLE',
    defaultMessage: 'INTERPRETER_UNAVAILABLE'
  },
  SIMILAR_PRESTATION_EXIST: {
    id: 'prestation.SIMILAR_PRESTATION_EXIST',
    defaultMessage: 'SIMILAR_PRESTATION_EXIST'
  },
  CARREFUL_SIMILAR_PRESTATION_EXIST: {
    id: 'prestation.CARREFUL_SIMILAR_PRESTATION_EXIST',
    defaultMessage: 'CARREFUL_SIMILAR_PRESTATION_EXIST'
  },
  CONFIRM_SIMILAR_PRESTATION_EXIST: {
    id: 'prestation.CONFIRM_SIMILAR_PRESTATION_EXIST',
    defaultMessage: 'CONFIRM_SIMILAR_PRESTATION_EXIST'
  },
  PRESTATION_CRITERIAS: {
    id: 'prestation.PRESTATION_CRITERIAS',
    defaultMessage: 'PRESTATION_CRITERIAS'
  },
  PRESTATION_INFORMATION: {
    id: 'prestation.PRESTATION_INFORMATION',
    defaultMessage: 'PRESTATION_INFORMATION'
  },
  PRESTATION_LOCATION: {
    id: 'prestation.PRESTATION_LOCATION',
    defaultMessage: 'PRESTATION_LOCATION'
  },
  PRESTATION_AVAILABILITIES: {
    id: 'prestation.PRESTATION_AVAILABILITIES',
    defaultMessage: 'PRESTATION_AVAILABILITIES'
  },
  PRESTATION_INTERPRETERS: {
    id: 'prestation.PRESTATION_INTERPRETERS',
    defaultMessage: 'PRESTATION_INTERPRETERS'
  },
  NATIONALITY_ORIGIN: {
    id: 'prestation.NATIONALITY_ORIGIN',
    defaultMessage: 'NATIONALITY_ORIGIN'
  },
  GENDER: {
    id: 'prestation.GENDER',
    defaultMessage: 'GENDER'
  },
  QUALIFICATIONS: {
    id: 'prestation.QUALIFICATIONS',
    defaultMessage: 'QUALIFICATIONS'
  },
  SKILLS: {
    id: 'prestation.SKILLS',
    defaultMessage: 'SKILLS'
  },
  INTERPRETER_UNAVAILABLE_CRITERIAS: {
    id: 'prestation.INTERPRETER_UNAVAILABLE_CRITERIAS',
    defaultMessage: 'INTERPRETER_UNAVAILABLE_CRITERIAS'
  },
  INTERPRETER_UNAVAILABLE_TIME1: {
    id: 'prestation.INTERPRETER_UNAVAILABLE_TIME1',
    defaultMessage: 'INTERPRETER_UNAVAILABLE_TIME1'
  },
  INTERPRETER_UNAVAILABLE_TIME2: {
    id: 'prestation.INTERPRETER_UNAVAILABLE_TIME2',
    defaultMessage: 'INTERPRETER_UNAVAILABLE_TIME2'
  },
  INTERPRETER_UNAVAILABLE_TIME3: {
    id: 'prestation.INTERPRETER_UNAVAILABLE_TIME3',
    defaultMessage: 'INTERPRETER_UNAVAILABLE_TIME3'
  },
  PRESTATION_VALIDATION: {
    id: 'prestation.PRESTATION_VALIDATION',
    defaultMessage: 'PRESTATION_VALIDATION'
  },
  LANGUAGE_MESSAGE: {
    id: 'prestation.LANGUAGE_MESSAGE',
    defaultMessage: 'LANGUAGE_MESSAGE'
  },
  DATE_INVALID: {
    id: 'prestation.DATE_INVALID',
    defaultMessage: 'DATE_INVALID'
  },
  DATE_FORMAT: {
    id: 'prestation.DATE_FORMAT',
    defaultMessage: 'DATE_FORMAT'
  },
  TIME_INVALID: {
    id: 'prestation.TIME_INVALID',
    defaultMessage: 'TIME_INVALID'
  },
  TIME_FORMAT: {
    id: 'prestation.TIME_FORMAT',
    defaultMessage: 'TIME_FORMAT'
  },
  PASS_COVID_MANDATORY: {
    id: 'prestation.PASS_COVID_MANDATORY',
    defaultMessage: 'PASS_COVID_MANDATORY'
  },
  TWO_DAYS_PRESTATION: {
    id: 'prestation.TWO_DAYS_PRESTATION',
    defaultMessage: 'TWO_DAYS_PRESTATION'
  },
  DUPLICATE_ACTION_LABEL: {
    id: 'prestation.DUPLICATE_ACTION_LABEL',
    defaultMessage: 'DUPLICATE_ACTION_LABEL'
  },
  CANCELLED_MESSAGE: {
    id: 'prestation.CANCELLED_MESSAGE',
    defaultMessage: 'CANCELLED_MESSAGE'
  },
  PRESTATION_EVALUATION: {
    id: 'prestation.PRESTATION_EVALUATION',
    defaultMessage: 'PRESTATION_EVALUATION'
  },
  PRESTATION_EVALUATION_DESCRIPTION: {
    id: 'prestation.PRESTATION_EVALUATION_DESCRIPTION',
    defaultMessage: 'PRESTATION_EVALUATION_DESCRIPTION'
  },
  PRESTATION_OPTIONAL_DESCRIPTION: {
    id: 'prestation.PRESTATION_OPTIONAL_DESCRIPTION',
    defaultMessage: 'PRESTATION_OPTIONAL_DESCRIPTION'
  },
  SATISFACTION: {
    id: 'prestation.SATISFACTION',
    defaultMessage: 'SATISFACTION'
  },
  ABSOLUTELY: {
    id: 'prestation.ABSOLUTELY',
    defaultMessage: 'ABSOLUTELY'
  },
  RATHER_YES: {
    id: 'prestation.RATHER_YES',
    defaultMessage: 'RATHER_YES'
  },
  RATHER_NO: {
    id: 'prestation.RATHER_NO',
    defaultMessage: 'RATHER_NO'
  },
  NOT_AT_ALL: {
    id: 'prestation.NOT_AT_ALL',
    defaultMessage: 'NOT_AT_ALL'
  },
  NO_ANSWER: {
    id: 'prestation.NO_ANSWER',
    defaultMessage: 'NO_ANSWER'
  },
  INTERPRETATION: {
    id: 'prestation.INTERPRETATION',
    defaultMessage: 'INTERPRETATION'
  },
  INTERPRETATION_NOTE: {
    id: 'prestation.INTERPRETATION_NOTE',
    defaultMessage: 'INTERPRETATION_NOTE'
  },
  UNDERSTANDING_NOTE: {
    id: 'prestation.UNDERSTANDING_NOTE',
    defaultMessage: 'UNDERSTANDING_NOTE'
  },
  COMMUNICATION_NOTE: {
    id: 'prestation.COMMUNICATION_NOTE',
    defaultMessage: 'COMMUNICATION_NOTE'
  },
  ORGANISATION: {
    id: 'prestation.ORGANISATION',
    defaultMessage: 'ORGANISATION'
  },
  ORGANISATION_NOTE: {
    id: 'prestation.ORGANISATION_NOTE',
    defaultMessage: 'ORGANISATION_NOTE'
  },
  PROCESS_NOTE: {
    id: 'prestation.PROCESS_NOTE',
    defaultMessage: 'PROCESS_NOTE'
  },
  COMPLEMENTARY_TOOLS_NOTE: {
    id: 'prestation.COMPLEMENTARY_TOOLS_NOTE',
    defaultMessage: 'COMPLEMENTARY_TOOLS_NOTE'
  },
  FEED_BACK: {
    id: 'prestation.FEED_BACK',
    defaultMessage: 'FEED_BACK'
  },
  REMARKS: {
    id: 'prestation.REMARKS',
    defaultMessage: 'REMARKS'
  },
  VERY_GOOD: {
    id: 'prestation.VERY_GOOD',
    defaultMessage: 'VERY_GOOD'
  },
  GOOD: {
    id: 'prestation.GOOD',
    defaultMessage: 'GOOD'
  },
  SUFFISANT: {
    id: 'prestation.SUFFISANT',
    defaultMessage: 'SUFFISANT'
  },
  INSUFFISANT: {
    id: 'prestation.INSUFFISANT',
    defaultMessage: 'INSUFFISANT'
  },
  COMMENT: {
    id: 'prestation.COMMENT',
    defaultMessage: 'COMMENT'
  },
  PHONE: {
    id: 'prestation.PHONE',
    defaultMessage: 'PHONE'
  },
  ADDRESS: {
    id: 'prestation.ADDRESS',
    defaultMessage: 'ADDRESS'
  },  
  EMAIL: {
    id: 'prestation.EMAIL',
    defaultMessage: 'EMAIL'
  },
  SEND_EVALUATION: {
    id: 'prestation.SEND_EVALUATION',
    defaultMessage: 'SEND_EVALUATION'
  },
  ADDRESS_AUTOCOMPLETE_MESSAGE: {
    id: 'prestation.ADDRESS_AUTOCOMPLETE_MESSAGE',
    defaultMessage: 'ADDRESS_AUTOCOMPLETE_MESSAGE'
  },
  GLOBAL_AUTOCOMPLETE_MESSAGE: {
    id: 'prestation.GLOBAL_AUTOCOMPLETE_MESSAGE',
    defaultMessage: 'GLOBAL_AUTOCOMPLETE_MESSAGE'
  },
  PRESTATION_EVALUATION_SENT: {
    id: 'prestation.PRESTATION_EVALUATION_SENT',
    defaultMessage: 'PRESTATION_EVALUATION_SENT'
  },
  BACK_TO_LOGIN: {
    id: 'prestation.BACK_TO_LOGIN',
    defaultMessage: 'BACK_TO_LOGIN'
  },
  CONTACT_INFORMATION: {
    id: 'prestation.CONTACT_INFORMATION',
    defaultMessage: 'CONTACT_INFORMATION'
  },
  NAME: {
    id: 'prestation.NAME',
    defaultMessage: 'NAME'
  },
  UKRAINE_ALERT_MESSAGE1: {
    id: 'prestation.UKRAINE_ALERT_MESSAGE1',
    defaultMessage: 'UKRAINE_ALERT_MESSAGE1'
  },
  UKRAINE_ALERT_MESSAGE2: {
    id: 'prestation.UKRAINE_ALERT_MESSAGE2',
    defaultMessage: 'UKRAINE_ALERT_MESSAGE2'
  },
  UKRAINE_ALERT_MESSAGE3: {
    id: 'prestation.UKRAINE_ALERT_MESSAGE3',
    defaultMessage: 'UKRAINE_ALERT_MESSAGE3'
  },
  UKRAINE_ALERT_MESSAGE4: {
    id: 'prestation.UKRAINE_ALERT_MESSAGE4',
    defaultMessage: 'UKRAINE_ALERT_MESSAGE4'
  },
  ADDITIONAL_SERVICE_ONLY_LABEL: {
    id: 'prestation.ADDITIONAL_SERVICE_ONLY_LABEL',
    defaultMessage: 'ADDITIONAL_SERVICE_ONLY_LABEL'
  },
  INITIAL_BENEFICIARY_NUMBER: {
    id: 'prestation.INITIAL_BENEFICIARY_NUMBER',
    defaultMessage: 'ADDITIONAL_SERVICE_ONLY_LABEL'
  },
  SALARY_REPORT_TITLE: {
    id: 'prestation.SALARY_REPORT_TITLE',
    defaultMessage: 'SALARY_REPORT_TITLE'
  },
  PROVISIONAL_SALARY_TITLE: {
    id: 'prestation.PROVISIONAL_SALARY_TITLE',
    defaultMessage: 'PROVISIONAL_SALARY_TITLE'
  },
  PERIOD_LABEL: {
    id: 'prestation.PERIOD_LABEL',
    defaultMessage: 'PERIOD_LABEL'
  },
  SALARY_PERIOD_LABEL: {
    id: 'prestation.SALARY_PERIOD_LABEL',
    defaultMessage: 'SALARY_PERIOD_LABEL'
  },
  PROVISIONAL_SALARY_PERIOD_LABEL: {
    id: 'prestation.PROVISIONAL_SALARY_PERIOD_LABEL',
    defaultMessage: 'PROVISIONAL_SALARY_PERIOD_LABEL'
  },
  SALARY_REPORT_FILE: {
    id: 'prestation.SALARY_REPORT_FILE',
    defaultMessage: 'SALARY_REPORT_FILE'
  },
  PROVISIONAL_SALARY_FILE: {
    id: 'prestation.PROVISIONAL_SALARY_FILE',
    defaultMessage: 'PROVISIONAL_SALARY_FILE'
  },
  ERROR_FETCHING_DOCUMENT: {
    id: 'prestation.ERROR_FETCHING_DOCUMENT',
    defaultMessage: "An error occurred while fetching the document.",
  },
  RESEND_AFTER_CANCELLATION: {
    id: 'prestation.RESEND_AFTER_CANCELLATION',
    defaultMessage: "RESEND_AFTER_CANCELLATION"
  },
  SEND_DATE: {
    id: 'prestation.SEND_DATE',
    defaultMessage: "SEND_DATE"
  },
  RESENT_LABEL: {
    id: 'prestation.RESENT_LABEL',
    defaultMessage: 'RESENT_LABEL'  
  },
  ARCHIVED: {
    id: 'prestation.ARCHIVED',
    defaultMessage: 'ARCHIVED'     
  },
  ARCHIVED_TOOLTIP: {
    id: 'prestation.ARCHIVED_TOOLTIP',
    defaultMessage: 'ARCHIVED_TOOLTIP'     
  }
})



// WEBPACK FOOTER //
// ./src/constants/Prestation.js